export const NOTIFICACAO_ADMIN_LISTAR_DESTINATARIOS =
  "NOTIFICACAO_ADMIN_LISTAR_DESTINATARIOS";
export const NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO =
  "NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO";
export const NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO =
  "NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO";
export const NOTIFICACAO_ADMIN_EXCLUIR_DESTINATARIO =
  "NOTIFICACAO_ADMIN_EXCLUIR_DESTINATARIO";
export const NOTIFICACAO_ADMIN_OBTER_EVENTOS =
  "NOTIFICACAO_ADMIN_OBTER_EVENTOS";
export const NOTIFICACAO_ADMIN_SALVAR_EVENTOS =
  "NOTIFICACAO_ADMIN_SALVAR_EVENTOS";
export const NOTIFICACAO_ADMIN_EMAIL_CONFIG = "NOTIFICACAO_ADMIN_EMAIL_CONFIG";
export const NOTIFICACAO_ADMIN_TEMPLATES_ESCOLHIDOS =
  "NOTIFICACAO_ADMIN_TEMPLATES_ESCOLHIDOS";
